export const RECEIVE_USERS = 'RECEIVE_USERS';
export const SORT_USERS = 'SORT_USERS';
export const ADD_USER = 'ADD_USER';
export const REMOVE_USER = 'REMOVE_USER';
